import axios, { AxiosError, AxiosRequestConfig } from "axios";

interface ApiErrorResponse {
    message?: string;
}

interface ApiError {
    message: string;
    status?: number;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8080';

// Configuration de base sans header Content-Type par défaut
const missionApiClient = axios.create({
    baseURL: `${API_BASE_URL}/api/v1`
});

const candidatureApiClient = axios.create({
    baseURL: `${API_BASE_URL}/api/v1`
});

// Variables d'authentification
let isAuthenticated = false;
let accessToken: string | null = null;

export const updateAuthState = (authState: { isAuthenticated: boolean; accessToken: string | null }) => {
    isAuthenticated = authState.isAuthenticated;
    accessToken = authState.accessToken;
};

// Intercepteur amélioré
const addAuthInterceptor = (client: typeof missionApiClient) => {
    client.interceptors.request.use(
        (config) => {
            if (!isAuthenticated) {
                throw new Error("Utilisateur non authentifié. Veuillez vous connecter.");
            }
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    client.interceptors.response.use(
        (response) => response,
        (error: AxiosError<ApiErrorResponse>) => {
            if (error.response?.status === 401) {
                window.location.href = "/connexion";
                return Promise.reject(new Error("Session expirée. Veuillez vous reconnecter."));
            }

            const apiError: ApiError = {
                message: error.response?.data?.message || error.message || "Erreur inconnue",
                status: error.response?.status,
            };
            return Promise.reject(apiError);
        }
    );
};

addAuthInterceptor(missionApiClient);
addAuthInterceptor(candidatureApiClient);

export { missionApiClient, candidatureApiClient };